import { IApplicationState } from '../../types/redux';

export const selectConstructionProgressLast = (state: IApplicationState) => {
  const { isLast } = state.constructionProgressData;

  return isLast;
};
